import { render, staticRenderFns } from "./SmsBroadcastOptions.vue?vue&type=template&id=0f589580&scoped=true"
import script from "./SmsBroadcastOptions.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastOptions.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastOptions.vue?vue&type=style&index=0&id=0f589580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f589580",
  null
  
)

export default component.exports